import { UtensilsCrossed, Hotel, Plane, ShoppingBag, Briefcase, Wrench, MessageCircle, Megaphone,
  Car, Scissors, HeartPulse, Dumbbell, GraduationCap, Baby, PawPrint, Music, Camera, Home, Truck, Gift, Store, Sparkles } from "lucide-react";

import React from "react";

const imgIcon = (n) => {
  const C = ({ className = "", style }) => React.createElement("span", {
    className: `inline-block shrink-0 ${className}`, "aria-hidden": true,
    style: { backgroundColor: "currentColor", WebkitMask: `url(/cat-icons/${n}.png?v=2) center/contain no-repeat`, mask: `url(/cat-icons/${n}.png?v=2) center/contain no-repeat`, ...style },
  });
  return C;
};
const IMG_ICONS = Object.fromEntries(["ushqim", "banim", "udhetim", "dyqan", "pune", "sherbime", "elektronike", "shendet", "patundshmeri", "komunitet", "reklame", "kafshe"].map((n) => [`Img_${n}`, imgIcon(n)]));

export const ICONS = { UtensilsCrossed, Hotel, Plane, ShoppingBag, Briefcase, Wrench, MessageCircle, Megaphone,
  Car, Scissors, HeartPulse, Dumbbell, GraduationCap, Baby, PawPrint, Music, Camera, Home, Truck, Gift, Store, Sparkles, ...IMG_ICONS };

export const MARKER_EMOJIS = [
  "🍽️", "🍕", "🍔", "🌯", "🥙", "🍖", "🍗", "🍝", "🍣", "🥗", "🥐", "🍞", "🥧", "🍰", "🎂", "🍨", "🍩", "☕", "🧋", "🍺", "🍷", "🍸", "🍹",
  "🏨", "🏠", "🏡", "🏢", "🏬", "🛏️", "🚪", "🔑", "🏕️", "⛺", "🏖️",
  "✈️", "🚌", "🚍", "🚕", "🚖", "🚐", "🚆", "⛴️", "🚢", "📦", "🚚", "🧳", "🗺️",
  "🛍️", "🛒", "🏪", "👗", "👕", "👟", "💄", "📱", "💻", "💎", "🌸", "🧸", "💊", "🥩", "🍎",
  "🔧", "🛠️", "🔌", "🚿", "🧱", "🎨", "🧹", "🚗", "💇", "💈", "💅", "📷", "🖥️", "🌱", "🪚", "✂️",
  "💼", "🏥", "⚽", "🏋️", "🎓", "👶", "🐾", "🎵", "🎁", "💬", "📢", "⭐", "📍",
];

export const MAP_ICONS = Array.from({ length: 63 }, (_, i) => `@${i + 1}`);
export const markerHtml = (v) => (v?.startsWith("@") ? `<img src="/map-icons/${v.slice(1)}.png" alt="" class="gs-pin-img"/>` : v);
export const MarkerGlyph = ({ v, className = "w-6 h-6" }) => (v?.startsWith("@") ? React.createElement("img", { src: `/map-icons/${v.slice(1)}.png`, alt: "", className: `${className} object-contain` }) : v);

export const SUB_EMOJI = {};
export const markerEmoji = (cat, sub) => (sub && SUB_EMOJI[cat]?.[sub]) || CAT_EMOJI[cat] || "📍";

export const CAT_EMOJI = { ushqim: "🍽️", banim: "🏨", udhetim: "✈️", dyqan: "🛍️", pune: "💼", sherbime: "🔧", komunitete: "💬", punekerkues: "👤", reklame: "📢" };

export const CATEGORIES = [
  { key: "ushqim", label: "Ushqim / Pije", tagline: "Restorante, Kafe, Bar", icon: UtensilsCrossed, grad: "from-red-500 to-rose-600", solid: "bg-red-500", text: "text-red-600", light: "bg-red-50", border: "border-red-200", marker: "#EF4444" },
  { key: "banim", label: "Banim & Qëndrim", tagline: "Hotel, Banesë, Dhoma", icon: Hotel, grad: "from-orange-500 to-amber-600", solid: "bg-orange-500", text: "text-orange-600", light: "bg-orange-50", border: "border-orange-200", marker: "#F97316" },
  { key: "udhetim", label: "Udhëtim", tagline: "Autobus, Aeroplan, Taxi", icon: Plane, grad: "from-blue-500 to-indigo-600", solid: "bg-blue-500", text: "text-blue-600", light: "bg-blue-50", border: "border-blue-200", marker: "#3B82F6" },
  { key: "dyqan", label: "Dyqan", tagline: "Dyqane & Produkte", icon: ShoppingBag, grad: "from-pink-500 to-rose-500", solid: "bg-pink-500", text: "text-pink-600", light: "bg-pink-50", border: "border-pink-200", marker: "#EC4899" },
  { key: "pune", label: "Punë", tagline: "Job & Karrierë", icon: Briefcase, grad: "from-yellow-400 to-amber-500", solid: "bg-yellow-500", text: "text-yellow-700", light: "bg-yellow-50", border: "border-yellow-200", marker: "#EAB308" },
  { key: "sherbime", label: "Shërbime", tagline: "Zejtarë & Mjeshtër", icon: Wrench, grad: "from-emerald-500 to-green-600", solid: "bg-emerald-500", text: "text-emerald-600", light: "bg-emerald-50", border: "border-emerald-200", marker: "#10B981" },
  { key: "reklame", label: "Reklamë", tagline: "🇽🇰 🇦🇱 🇲🇰 🇲🇪", icon: Megaphone, grad: "from-fuchsia-500 to-purple-600", solid: "bg-fuchsia-500", text: "text-fuchsia-600", light: "bg-fuchsia-50", border: "border-fuchsia-200", marker: "#D946EF", route: "/reklame" },
  { key: "komunitete", label: "Komunitete", tagline: "Biseda & Pyetje", icon: MessageCircle, grad: "from-cyan-400 to-sky-500", solid: "bg-cyan-500", text: "text-cyan-600", light: "bg-cyan-50", border: "border-cyan-200", marker: "#06B6D4", route: "/komunitete" },
];

export const catMap = Object.fromEntries(CATEGORIES.map((c) => [c.key, c]));

const hexRgb = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16));
const dark = (h) => "#" + hexRgb(h).map((v) => Math.round(v * 0.78).toString(16).padStart(2, "0")).join("");

function colorClasses(key, hex) {
  const [r, g, b] = hexRgb(hex);
  const p = `gsc-${key}`;
  return {
    css: `.${p}-grad{--tw-gradient-from:${hex} var(--tw-gradient-from-position);--tw-gradient-to:${dark(hex)} var(--tw-gradient-to-position);--tw-gradient-stops:var(--tw-gradient-from),var(--tw-gradient-to)}
.${p}-solid{background-color:${hex}}.${p}-text{color:${dark(hex)}}.${p}-light{background-color:rgba(${r},${g},${b},.1)}.${p}-border{border-color:rgba(${r},${g},${b},.35)}`,
    cls: { grad: `${p}-grad`, solid: `${p}-solid`, text: `${p}-text`, light: `${p}-light`, border: `${p}-border`, marker: hex },
  };
}

// Apply admin-managed names/colors/icons/markers/subcategories (mutates in place so imports stay live)
export function applyCategories(items) {
  if (!Array.isArray(items)) return;
  let css = "";
  items.forEach((it) => {
    let c = catMap[it.key];
    if (!c && it.custom) {
      c = { key: it.key, icon: Store, custom: true, ...colorClasses(it.key, it.color || "#64748B").cls };
      const at = CATEGORIES.findIndex((x) => x.key === "reklame");
      CATEGORIES.splice(at < 0 ? CATEGORIES.length : at, 0, c);
      catMap[it.key] = c;
    }
    if (!c) return;
    c.label = it.label || c.label;
    c.tagline = it.tagline ?? c.tagline;
    c.colorHex = it.color || c.colorHex;
    c.iconName = it.icon || c.iconName;
    if (it.icon && ICONS[it.icon]) c.icon = ICONS[it.icon];
    if (it.emoji) CAT_EMOJI[it.key] = it.emoji;
    SUB_EMOJI[it.key] = { ...(it.sub_emojis || {}) };
    if (it.color) { const cc = colorClasses(it.key, it.color); Object.assign(c, cc.cls); css += cc.css + "\n"; }
    if (Array.isArray(it.subs) && it.subs.length) {
      if (SUBCATEGORIES[it.key]) SUBCATEGORIES[it.key].splice(0, SUBCATEGORIES[it.key].length, ...it.subs);
      else SUBCATEGORIES[it.key] = [...it.subs];
    }
  });
  let el = document.getElementById("gs-cat-colors");
  if (!el) { el = document.createElement("style"); el.id = "gs-cat-colors"; document.head.appendChild(el); }
  el.textContent = css;
}

export function currentCategories() {
  return CATEGORIES.map((c) => ({
    key: c.key, label: c.label, tagline: c.tagline || "", color: c.colorHex || c.marker || "",
    icon: c.iconName || Object.keys(ICONS).find((n) => ICONS[n] === c.icon) || "",
    emoji: CAT_EMOJI[c.key] || "", subs: [...(SUBCATEGORIES[c.key] || [])], sub_emojis: { ...(SUB_EMOJI[c.key] || {}) }, custom: !!c.custom,
  }));
}

export const SUBCATEGORIES = {
  ushqim: ["Restorante", "Pizzeri", "Fast Food", "Kafe", "Bar", "Ëmbëltore", "Furrë Buke", "Të tjera"],
  banim: ["Hotel", "Shtëpi", "Banesë", "Dhoma", "Krevat", "Lokal", "Zyrë", "Autokamping", "Të tjera"],
  udhetim: ["Autobus", "Aeroplan", "Taxi", "Dërgesa", "Të tjera"],
  dyqan: ["Ushqimore", "Veshmbathje", "Berber", "Parukeri", "Estetikë", "Sallone Veturash", "Mobile", "Elektronikë", "Shëndetësi", "Të tjera"],
  pune: ["Kamerier", "Kuzhinier", "Bukëpjekës", "Ndihmës kuzhine", "Berber", "Parukier", "Estetist", "Elektricist", "Hidraulik", "Ndërtimtar", "Moler", "Saldues", "Mekanik", "Shofer", "Magazinier", "Punëtor fabrike", "Ndihmës", "Pastrues", "Kujdestar", "Infermier", "Punë në bujqësi", "Punë në hotel", "Punë në market", "IT / Teknologji", "Kontabilist", "Administratë", "Punë sezonale", "Taksist", "Të tjera"],
  sherbime: ["Hidraulik", "Elektricist", "Ndërtim", "Lyerje", "Pastrim", "Mekanik", "Transport", "Dërgesa", "Berber", "Estetikë", "Foto / Video", "IT", "Riparim telefonash", "Mirëmbajtje", "Kopshtari", "Catering", "Mësime", "Kujdes", "Zhvendosje", "Çelësa / Brava", "Klimë / Ngrohje", "Të tjera"],
};

export const REKLAME_SUBS = ["Ushqime/Pije", "Udhëtim", "Banim/Qëndrim", "Dyqan", "Shërbime"];
SUBCATEGORIES.reklame = REKLAME_SUBS;

export const COMMUNITY = {
  countries: ["Suedi", "Gjermani", "Zvicër", "Norvegji", "Austri", "Danimarkë", "Francë", "Itali", "Belgjikë", "Holandë", "Kosovë", "Shqipëri"],
  topics: ["Pyetje & Përgjigje", "Punë", "Banesa & Qira", "Transport", "Shitje & Blerje", "Makina", "Biznese", "Njoftime"],
};

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "tani";
  if (s < 3600) return `${Math.floor(s / 60)} min më parë`;
  if (s < 86400) return `${Math.floor(s / 3600)} orë më parë`;
  if (s < 2592000) return `${Math.floor(s / 86400)} ditë më parë`;
  return d.toLocaleDateString("sq-AL");
}
